import { useQuery } from "react-query";
import { getProcessModels } from "../services/finance/processModels";
import { PagedRequestType } from "../types/PagedResults";
import { Key_processModels } from "../utils/constants";

export const useGetProcessModelsQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_processModels, JSON.stringify(data)],
    () => getProcessModels(data),
    options ? { ...options } : {}
  );